import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { ColumnData, BaseItem } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { QuickTableEditingInfo } from '../elements/QuickTable/QuickTableMisc';
import { DynProperty } from '@shared/commons/DynProperty';
import { ThemeManager } from '../misc/ThemeManager';
export class WebhookTableItem extends BaseItem {
    constructor(webhook, settings) {
        super(settings);
        this.webhook = webhook;
        this.QuickTableEditingInfoMap[WebhookTableItem.DELETE_COL_INDEX] = new QuickTableEditingInfo(DynProperty.CLOSE_BUTTON);
    }
    getColumnValue(column, useAccCurrency) {
        switch (column) {
            case WebhookTableItem.NAME_COL_INDEX:
                return isValidString(this.webhook.name) ? this.webhook.name : '';
            case WebhookTableItem.CREATION_DATE_COL_INDEX:
                return this.webhook.creationDate;
            case WebhookTableItem.EXPIRATION_DATE_COL_INDEX:
                return this.webhook.expirationDate;
            case WebhookTableItem.DELETE_COL_INDEX:
                return '';
            default:
                return undefined;
        }
    }
    getColumnData(column) {
        var _a;
        const value = this.getColumnValue(column);
        let formattedValue = '';
        switch (column) {
            case WebhookTableItem.CREATION_DATE_COL_INDEX:
            case WebhookTableItem.EXPIRATION_DATE_COL_INDEX:
                if (value !== null) {
                    formattedValue = DateTimeUtils.FormatToDate(value);
                }
                break;
            default:
                formattedValue = (_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : '';
        }
        return new ColumnData(value, formattedValue);
    }
    GetColumnParams(column) {
        return WebhookTableItem.columnsParams[column];
    }
    ColumnCount() {
        return WebhookTableItem.columnsParams.length;
    }
    getQuickTableCellForeground(column) {
        if (column === WebhookTableItem.NAME_COL_INDEX) {
            return ThemeManager.colors.tableSymbolForeground;
        }
        else {
            return super.getQuickTableCellForeground(column);
        }
    }
}
WebhookTableItem.NAME_COL_INDEX = 0;
WebhookTableItem.CREATION_DATE_COL_INDEX = 1;
WebhookTableItem.EXPIRATION_DATE_COL_INDEX = 2;
WebhookTableItem.DELETE_COL_INDEX = 3;
WebhookTableItem.columnsParams = [
    new ColumnParams('screen.Webhooks.name', 100, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('screen.Webhooks.creationDate', 100, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('screen.Webhooks.expirationDate', 100, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('screen.Webhooks.delete', 100, QTAlignment.Left, TableTotalsVisibility.None, true, false)
];
